import { render, staticRenderFns } from "./VocabularyUpdate.vue?vue&type=template&id=6f3e13dc&scoped=true&"
import script from "./VocabularyUpdate.vue?vue&type=script&lang=js&"
export * from "./VocabularyUpdate.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyUpdate.vue?vue&type=style&index=0&id=6f3e13dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e13dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VImg,VRow,VSelect,VSpacer,VSwitch,VTextarea})
